package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.styles.Motion
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.StyleScope

private const val ROW_HEIGHT = "3rem"
private const val MIN_FILL_WIDTH = "12rem"
private const val MIN_WRAP_WIDTH = "16rem"
private const val CAPPED_WIDTH = "12rem"

@InitSilk
fun initLogTableStyles(ctx: InitSilkContext) {
    fun rule(selector: String, build: StyleScope.() -> Unit) {
        ctx.stylesheet.registerStyle(selector) { base { Modifier.styleModifier(build) } }
    }

    val table = ".${LogTableClasses.TABLE}"
    val ruleLine = "1px solid ${Palette.borderSubtle.cssRgb()}"

    rule(table) {
        property("width", "100%")
        property("border-collapse", "collapse")
    }
    rule("$table th") {
        property("text-align", "left")
        property("font-size", Typography.caption.size.toString())
        property("font-weight", "400")
        property("line-height", LogTableClasses.LINE_HEIGHT)
        property("color", Palette.textTertiary.cssRgb())
        property("padding", "0 ${Spacing.sm} ${Spacing.xs}")
        property("border-bottom", "1px solid ${Palette.border.cssRgb()}")
        property("white-space", "nowrap")
    }
    rule("$table td") {
        property("padding", Spacing.sm.toString())
        property("border-bottom", ruleLine)
        property("vertical-align", "middle")
        property("height", ROW_HEIGHT)
        property("line-height", LogTableClasses.LINE_HEIGHT)
        property("transition", Motion.transition(Motion.DUR_FAST, "background-color"))
    }
    rule("$table th:first-child") { property("padding-left", "0") }
    rule("$table td:first-child") { property("padding-left", "0") }
    rule("$table th:last-child") { property("padding-right", "0") }
    rule("$table td:last-child") { property("padding-right", "0") }
    rule("$table .${LogTableClasses.END}") {
        property("text-align", "right")
        property("white-space", "nowrap")
        property("font-variant-numeric", "tabular-nums")
    }
    rule("$table tr.${LogTableClasses.ROW}") { property("cursor", "pointer") }
    rule("$table tr.${LogTableClasses.ROW}:hover td") { property("background-color", Palette.surfaceHover.cssRgb()) }
    rule("$table tr.${LogTableClasses.ROW}[aria-expanded=\"true\"] td") { property("border-bottom-color", "transparent") }
    rule("$table td.${LogTableClasses.DETAIL}") {
        property("padding", "0 0 ${Spacing.sm}")
        property("height", "auto")
        property("vertical-align", "top")
        property("cursor", "default")
    }
    rule("$table td.${LogTableClasses.FILL}") {
        property("width", "100%")
        property("min-width", MIN_FILL_WIDTH)
        property("max-width", "0")
    }
    rule("$table td.${LogTableClasses.WRAP}") {
        property("width", "100%")
        property("min-width", MIN_WRAP_WIDTH)
        property("overflow-wrap", "anywhere")
    }
    rule(".${LogTableClasses.CLIP}") {
        property("display", "block")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        property("white-space", "nowrap")
    }
    rule(".${LogTableClasses.CAP}") { property("max-width", CAPPED_WIDTH) }
}
